import { Input } from '@/components/ui/input';
import { RainbowButton } from '@/components/ui/rainbow-button';
import { FormEvent, useEffect, useState } from 'react';

interface AuthFormProps {
  onEmailSubmit: (email: string, password?: string) => void;
  isLoading: boolean;
}

const TEST_EMAIL = 'example@clue.com';

export const AuthForm = ({ onEmailSubmit, isLoading }: AuthFormProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Show password field if it's the test email and password auth is enabled
    setShowPassword(email.toLowerCase() === TEST_EMAIL.toLowerCase());
  }, [email]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onEmailSubmit(email, showPassword ? password : undefined);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-4 w-full">
        <div>
          <label className="text-left block font-semibold mb-2">Email</label>
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            placeholder="tupac@shakur.com"
            required
          />
        </div>

        {showPassword && (
          <div>
            <label className="text-left block font-semibold mb-2">
              Password
            </label>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Enter your password"
              required
            />
          </div>
        )}

        <RainbowButton
          disabled={isLoading}
          title={showPassword ? 'Sign in' : 'Send magic link'}
          type="submit"
          className="w-full text-white">
          {isLoading
            ? 'Loading...'
            : showPassword
              ? 'Sign in'
              : 'Send Magic Link'}
        </RainbowButton>
      </div>
    </form>
  );
};
